import { useEffect } from 'react';

import { useAtomValue } from 'jotai';

import { formStateAtom } from '@core/Atoms/Pdp/FormState.atom';
import { searchParamsAtom } from '@core/Atoms/SearchParams/SearchParams.atom';
import { userIdAtom } from '@core/Atoms/User/UserId.atom';
import { currentVehicleAtom } from '@core/Atoms/Vehicle/CurrentVehicle.atom';
import { image360ViewedToEvent } from '@tracking/Schemas/Image360/Image360ViewedToEvent';
import { vehicleToListingEvent } from '@tracking/Schemas/Listing/VehicleToListingEvent';
import { marketingToEvent } from '@tracking/Schemas/Marketing/MarketingToEvent';
import { userContextToEvent } from '@tracking/Schemas/UserContext/UserContextToEvent';
import { trackCustomEvent } from '@tracking/Utils/TrackCustomEvent';

export const useImage360Tracking = () => {
  const vehicle = useAtomValue(currentVehicleAtom)!;
  const searchParams = useAtomValue(searchParamsAtom);
  const userId = useAtomValue(userIdAtom)!;
  const formState = useAtomValue(formStateAtom);

  useEffect(() => {
    const marketingDataObj = { marketingValues: { ...searchParams } };
    const userData = { userId, values: { ...formState } };

    trackCustomEvent({
      event: image360ViewedToEvent({ listingId: vehicle?.heycarId, userId }),
      context: [
        vehicleToListingEvent(vehicle),
        userContextToEvent(userData),
        marketingToEvent(marketingDataObj),
      ],
    });
  }, []);
};
